import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useMantineTheme, Button as Button$1 } from '@mantine/core';
import { useButtonStyle, useButtonDynamicStyle } from './Button.style.js';
import { GUI_GLOBAL_CLASS, GUI_COMP_CSS_VARIABLE_CLASS } from '../../utils/index.js';
import { Icon } from '../Icon/Icon.js';

var _excluded = ["h", "fw", "hoverColor", "disabledBg", "disabledColor", "disabledBorderColor", "type", "htmlType", "rtlIcon", "isAdapt", "loading", "styles", "className", "classNames", "breakpoints", "applyColorVariable"];
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useMantineTheme();
  var h = props.h,
    fw = props.fw,
    hoverColor = props.hoverColor,
    disabledBg = props.disabledBg,
    disabledColor = props.disabledColor,
    disabledBorderColor = props.disabledBorderColor,
    _props$type = props.type,
    type = _props$type === void 0 ? 'primary' : _props$type,
    htmlType = props.htmlType,
    rtlIcon = props.rtlIcon,
    isAdapt = props.isAdapt,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    classNames = props.classNames,
    _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [] : _props$breakpoints,
    _props$applyColorVari = props.applyColorVariable,
    applyColorVariable = _props$applyColorVari === void 0 ? false : _props$applyColorVari,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useButtonStyle = useButtonStyle({
      breakpoints: breakpoints,
      type: type,
      size: restProps.size || 'md',
      notOnlyIcon: !!props.children || !!props.label
    }, {
      styles: styles,
      classNames: classNames,
      name: 'GateButton'
    }),
    cx = _useButtonStyle.cx,
    classes = _useButtonStyle.classes;
  restProps.leftIcon = restProps.leftIcon && React__default.Children.map(theme.dir === 'rtl' ? rtlIcon || restProps.leftIcon : restProps.leftIcon, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child) && child.type === Icon) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        className: classes.iconElement + ' ' + (child.props.className || '')
      });
    }
    return child;
  });
  restProps.rightIcon = restProps.rightIcon && React__default.Children.map(theme.dir === 'rtl' ? rtlIcon || restProps.rightIcon : restProps.rightIcon, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child) && child.type === Icon) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        className: classes.iconElement + ' ' + (child.props.className || '')
      });
    }
    return child;
  });
  return /*#__PURE__*/React__default.createElement(Button$1, _objectSpread2(_objectSpread2({
    fullWidth: isAdapt
  }, restProps), {}, {
    style: _objectSpread2(_objectSpread2({}, useButtonDynamicStyle({
      loading: loading,
      h: h,
      fw: fw,
      hoverColor: hoverColor,
      disabledBg: disabledBg,
      disabledColor: disabledColor,
      disabledBorderColor: disabledBorderColor
    })), restProps.style),
    type: htmlType,
    dir: theme.dir,
    className: cx(className, GUI_GLOBAL_CLASS, applyColorVariable ? GUI_COMP_CSS_VARIABLE_CLASS : undefined),
    classNames: classes,
    ref: ref
  }), props.children || props.label, loading ? /*#__PURE__*/React__default.createElement(ButtonLoadingEffect, {
    className: classes.loading
  }) : null);
});
var ButtonLoadingEffect = function ButtonLoadingEffect(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    width: "36px",
    height: "8px"
  }, /*#__PURE__*/React__default.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: "4",
    cy: "4",
    r: "4"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.1"
  })), /*#__PURE__*/React__default.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: "18",
    cy: "4",
    r: "4"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.2"
  })), /*#__PURE__*/React__default.createElement("circle", {
    fill: "currentColor",
    stroke: "none",
    cx: "32",
    cy: "4",
    r: "4"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: "0.3"
  })));
};

export { Button };
//# sourceMappingURL=Button.js.map
